module.exports = __webpack_public_path__ + "static/img/ai.65c2b371.png";